export enum ReportGroup {
    CampaignName = "campaign_name",
    AppName = "app_name",
    CRName = "cr_name",
    GoalName = "goal_name",
    Country = "country",
    City = "city",
    OS = "os",
    Month = "month",
    Hour = "hour",
    Date = "created",
    Status = "status",
  }